import React, { useEffect, useRef } from 'react';

interface Props {
  onClickOutside: (e: MouseEvent) => void;
  isHandlerDisabled: boolean;
  children: React.ReactNode;
}

const OutsideClickHandler = ({
  onClickOutside,
  isHandlerDisabled,
  children,
}: Props): React.ReactElement => {
  const container = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const handleOutsideClick = (e) => {
      if (container && !container.current.contains(e.target)) {
        onClickOutside(e);
      }
    };
    if (!isHandlerDisabled) {
      document.addEventListener('click', handleOutsideClick);
      return () => {
        document.removeEventListener('click', handleOutsideClick);
      };
    }
  }, [isHandlerDisabled, onClickOutside]);

  return <div ref={container}>{children}</div>;
};

export default OutsideClickHandler;
